import {createListenerMiddleware, isAnyOf} from "@reduxjs/toolkit";
import {authApi} from "@src/features/auth/redux/auth-api";
import {clearAuthState, setAuthState} from "@src/features/auth/redux/auth-slice";
import {authStorage} from "@src/features/auth/auth-storage";
import {appApi} from "@src/integrations/redux/app-api";
import type {AuthState} from "@src/features/auth/auth-models";


export const authMiddleware = createListenerMiddleware();


authMiddleware.startListening({
	matcher: isAnyOf(authApi.endpoints.verifyPhoneOtp.matchFulfilled,
		authApi.endpoints.verifyInvitePhone.matchFulfilled,
		authApi.endpoints.joinInviteWithCurrentSession.matchFulfilled,
		authApi.endpoints.refreshSession.matchFulfilled),
	effect: async (action, listenerApi) => {
		listenerApi.dispatch(setAuthState(action.payload as AuthState));
	}
});

authMiddleware.startListening.withTypes<{appApi: ReturnType<typeof authApi.reducer>}>()({
	matcher: isAnyOf(authApi.endpoints.verifyInvitePhone.matchFulfilled,
		authApi.endpoints.joinInviteWithCurrentSession.matchFulfilled),
	effect: async (action, listenerApi) => {
		if (!authApi.endpoints.verifyInvitePhone.matchFulfilled(action) &&
			!authApi.endpoints.joinInviteWithCurrentSession.matchFulfilled(action)) return;
		const args = action.meta.arg.originalArgs;
		const groupId = typeof args === 'string' ? args : args.groupId;
		// The verified server response is already authoritative; avoid another
		// session round trip when navigating straight to this group's rides.
		listenerApi.dispatch(authApi.util.updateQueryData('inviteContext', groupId, draft => {
			draft.session = action.payload;
		}));
	}
});

authMiddleware.startListening({
	matcher: authApi.endpoints.inviteLogOut.matchFulfilled,
	effect: async (_action, listenerApi) => {
		listenerApi.dispatch(clearAuthState());
	}
});


authMiddleware.startListening({
	matcher: authApi.endpoints.logOut.matchFulfilled,
	effect: async (_action, listenerApi) => {
		listenerApi.dispatch(clearAuthState());
	}
});


authMiddleware.startListening({
	actionCreator: setAuthState,
	effect: async (action, _listenerApi) => {
		authStorage.saveAuthState(action.payload);
	}
});


authMiddleware.startListening({
	actionCreator: clearAuthState,
	effect: async (_action, listenerApi) => {
		authStorage.clearAuthState();
		// Short-lived ride caches must not survive logout or account switching.
		listenerApi.dispatch(appApi.util.resetApiState());
	}
});
